import { AppContext } from '../context';
import { Redirect, Route, Switch } from 'react-router-dom';
import { UserAgent } from '../types';
import React, { useContext } from 'react';
import SuperdayConfirmPage from '../pages/Superday/Confirm';
import SuperdayEmailValidationPage from '../pages/Superday/Email';
import SuperdayExpiredPage from '../pages/Superday/Expired';
import SuperdayIntroPage from '../pages/Superday/Intro';
import SuperdayNoResultPage from '../pages/Superday/NoResult';
import SuperdayPickdaysPage from '../pages/Superday/Pickdays';
import SuperdaySignupConfirmPage from '../pages/Superday/Confirm/signup';
import SuperdaySignupPickdaysPage from '../pages/Superday/Pickdays/signup';

const PATH = '/s';
const SIGNUP_PATH = '/i';

const SuperdayRARoutes: React.FC = () => {
    const { setUserAgentHeader } = useContext(AppContext);
    setUserAgentHeader(UserAgent.SUPERDAY_REQUEST_AVAILABILITY);
    return (
        <Switch>
            <Route path={`${PATH}/`} exact>
                <Redirect to="/invalid-link" />
            </Route>
            <Route path={`${PATH}/(intro|pickDays|confirm|expired|no-result)/:hash`} component={SuperdayRAHashPath} />
            <Route
                path={`${SIGNUP_PATH}/:organizationSlug/(intro|pickDays|confirm|expired|no-result)/:customUrl`}
                component={SuperdayRASignupPath}
            />
        </Switch>
    );
};

const SuperdayRAHashPath = () => {
    return (
        <Switch>
            <Route path={`${PATH}/confirm/:hash`}>
                <SuperdayConfirmPage />
            </Route>
            <Route path={`${PATH}/expired/:hash`}>
                <SuperdayExpiredPage />
            </Route>
            <Route path={`${PATH}/intro/:hash`}>
                <SuperdayIntroPage />
            </Route>
            <Route path={`${PATH}/no-result/:hash`}>
                <SuperdayNoResultPage />
            </Route>
            <Route path={`${PATH}/pickDays/:hash`}>
                <SuperdayPickdaysPage />
            </Route>
        </Switch>
    );
};

const SuperdayRASignupPath = () => {
    return (
        <Switch>
            {/* signup paths */}
            <Route path={`${SIGNUP_PATH}/:organizationSlug/intro/:customUrl`}>
                <SuperdayEmailValidationPage />
            </Route>
            <Route path={`${SIGNUP_PATH}/:organizationSlug/confirm/:customUrl`}>
                <SuperdaySignupConfirmPage />
            </Route>

            <Route path={`${SIGNUP_PATH}/:organizationSlug/pickDays/:customUrl`}>
                <SuperdaySignupPickdaysPage />
            </Route>
        </Switch>
    );
};

export default SuperdayRARoutes;
